import * as React from 'react';

import { cn } from '../../lib/utils';
import { fieldVariants } from './field-variants';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(fieldVariants({ size: 'control' }), className)}
      {...props}
    />
  );
}

export { Input };
